import { defineComponent as _defineComponent } from 'vue'
import ProjectActionApply from '@/views/project-forum/components/sidebar-actions/ProjectActionApply.vue';
import RecommendProjectToUsers from '@/views/recommendations/components/recommend-project-to-users/RecommendProjectToUsers.vue';
import { computed, PropType } from 'vue';
import { InfoBoxType } from '@/models/InfoBox';
import { useVModel } from '@vueuse/core';
import useUser from '@/mixins/useUser';
import BCXSidebarAsLayer from '@/components/molecules/BCXSidebarAsLayer.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectActionLayers',
  props: {
  openedLayerType: {
    type: String as PropType<'' | 'apply' | 'recommend'>,
    default: ''
  }
},
  setup(__props) {

const props = __props;



const { tUserFallback: t } = useUser('self');
const openedLayerType = useVModel(props, 'openedLayerType');
const title = computed(() => `${t(
  props.openedLayerType === 'recommend'
    ? 'recommendations.recommend-to-user.title'
    : 'project-forum_USERTYPE.apply-box.title'
)
}`);


return { __sfc: true,props, t, openedLayerType, title, ProjectActionApply, RecommendProjectToUsers, InfoBoxType, BCXSidebarAsLayer }
}

})